import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatInput, MatLabel } from '@angular/material/input';
import { TranslocoPipe } from '@jsverse/transloco';

import { BaseControlValueAccessor } from '~core/abstractions/base-control-value-accessor';
import { ErrorTooltipDirective } from '~core/directives/error-tooltip.directive';

@Component({
    selector: 'arc-textarea',
    templateUrl: './textarea.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: TextareaComponent
        }
    ],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatFormField, ErrorTooltipDirective, MatLabel, MatInput, ReactiveFormsModule, TranslocoPipe]
})
export class TextareaComponent extends BaseControlValueAccessor<string> {
    @HostBinding('class') classes = 'grow';

    readonly minLength = input<number>();
    readonly maxLength = input<number>();
    readonly height = input<number>();

    onInput(): void {
        this.valueChanged(this.internalControl.value);
    }
}
